import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';

import ForgotPasswordForm from '../../sections/auth/ForgotPasswordForm';

export default function ForgotPasswordPage() {
  return (
    <Stack spacing={3}>
      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Typography variant="h4">Recuperar contraseña</Typography>
      </Stack>

      <ForgotPasswordForm />

      <Typography variant="body2" sx={{ textAlign: 'center' }}>
        <Link component={RouterLink} to="/login">
          Volver a iniciar sesión
        </Link>
      </Typography>
    </Stack>
  );
}
